export const locale = {
  lang: 'zh1',
  data: {
    'AVANCES': {
      'GOSURVEY':'去調查',
      'GOPORTAL':'前往計數門戶',
      'REGRESAR':'背部',
      'DESCARGAR':'下載文件',
      'PRIMEROS':'第一 1000',
      'SINCRONIZAR':'與計數門戶同步',
      'AGREGAR': '加',
      'PRODUCTO':'產品',
      'FEC-LAN':'啟動日期',
      'FEC-CIE':'結算日期',
      'NOFEC-LAN': "您尚未安排發布日期",
      'FEC-CIE-PROR':'關閉日期已延長',
      'CER': '仔細調查',
      'ABR': '公開調查',
      'PROR':'方案',
      'SURVEY':'調查: ',
      'FILE':'文件管理器: ',
      'WARNING-FECHA-GUARDAR':'您確定要添加過期的擴展程序嗎 ',
      'SUCCESS-PRORROGA': '截止日期已更改為 ',
      'WARNING-CIERRE-ENCUESTA':'您確定要更改調查狀態嗎',
      'SUCCESS-CIERRE': '調查已正確更改',
      'PORCENTAJE':'回應預覽： ',
      'DES':'點擊顯示    ',
      'WARNING-BTN':'目前，由於您的調查尚未啟動，因此我沒有採取此操作',
      'PROCESARRESU': '處理結果',
      'ETIQUETAS':{
        'ETIQUETAS': '每頁項目',
          'OF': '從',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>確認刪除用戶答案',
          'MESSAGE2':'，在文本框中輸入用戶名</span>',
          'MESSAGE3':'<span>確認刪除用戶答案，在文本框中輸入用戶名 ',
          'SALIR': '出口',
          'VALIDAR': '確認用戶',
          'ERRORNOMBREEMPRESA': '輸入的用戶名，與您要刪除的用戶名不匹配',
          'MENSAJE': '¿你確定嗎?\n\n您即將刪除用戶答案 ',
          'CANCELAR': '取消',
          'CONFIRMAR': '是的，刪除',
          'SUCCES': '答案被刪除',
          'CERRAR': '關'
        },
        'MESSAGE':'¿您確定要刪除答案嗎',
        'RESP_SI':'是',
        'RESP_NO':'沒有',
        'ACEPTAR':' 接受',
        'CANCELAR':'取消',
        'OK':'好',
        'SUCCESS-DELETE':'答案已成功刪除',
        'ERROR-DELETE':'發生錯誤',
      },
      'PROCESAR': {
        'OK': '該過程已成功啟動',
        'NOTOK': '該過程無法啟動，首先您需要設置所需的結果'
      },
      'INS':{
        'INS1':' 的 ',
        'INS2':' 合作者 '
      },
      'INICIO':{
        'TITULO':'用戶調查狀態',
        'INSTRUCCIONES':'左側是一個欄，上面有公司購買的產品。單擊其中之一按年份顯示客戶，請選擇其中一個以顯示進行該產品調查的用戶列表。',
      },
      'ENCUESTA':{
        'TTITULO': '用戶進度調查',
        'PRODUCTS':'自有產品',
        'LABEL01':'名稱',
        'LABEL02':'電子郵件',
        'LABEL03':'調查表',
        'LABEL04':'狀態',
        'LABEL05':'邀請函',
        'LABEL06':'提醒',
        'LABEL07':'刪除',
        'LABEL08':'開始',
        'LABEL09':'結束',
        'LABEL10':'動作',
        'LABEL11':'電子郵件動作',
        'LABEL12':'快捷鍵',
        'BUSCAR':'搜索',
        'CARGANDO':'載入中',
        'ACTIVA':'問卷調查未啟用',
        //, 請稍候...。您擁有的用戶總數為
        'PLACE':'輸入您要尋找的合作者的名字',
        'ACTIONS':'隱藏的動作',
        'NOUSER':'找不到搜尋',
        'NA':'無法使用',
        'ERROR':'該產品還沒有調查',
        'SUCCESS1':'邀請已發送',
        'SUCCESS2':'提醒已發送',
        'ERROR1':'發生錯誤',
      },
      'TITULOS':{
        'NAME':'協作者姓名',
        'ESTADOS':'調查狀態',
        'FECHA1':'調查開始',
        'FECHA2':'結束調查',
        'ESTADOS_ENC':{
          'TITULO':'選擇一個選項',
          'TODO':'顯示所有',
          'ESTADO1':'用戶尚未開始調查',
          'ESTADO2':'用戶已登錄',
          'ESTADO3':'進度調查',
          'ESTADO4':'用戶已完成調查',
          'ESTADO5':'不接受',
          'ESTADO6':'我接受調查',
        }
      },
      'COLUMNAS':{
        'email':'電子郵件',
        'end_date':'最後日期',
        'id_status':'州',
        'name':'名稱',
        'start_date':'開始日期'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'電子郵件動作',
        'INFO':'下一步向您顯示可行的操作給用戶',
        'ACC1':'發送邀請',
        'ACC2':'發送提醒',
        'ACC3':'刪除調查答案',
      },
      'NEWCOLAB': {
        'TITULO': '將新參與者添加到調查中',
        'INST_1': '完成每個必需的數據集以添加新參與者',
        'TITULO_MOD': '修改合作者數據',
        'INST_1_MOD': '您可以修改所選協作者的每個數據集',
        'INST_2': '標有（*）的字段為必填項',
        'WARNING1':'注意：此合作者的鑰匙 ',
        'WARNING2':' 無法修改',
        'DATASET_1': '數據集1',
        'DATASET_2': '數據集2',
        'DATASET_3': '數據集3',
        'DATASET_4': '數據集4',
        'DATASET_5': '數據集5',
        'DATASET_6': '數據集6',
        'DATASET_7': '數據集7',
        'REQUIRED': '這是必填欄',
        'NEXT': '下一個',
        'BACK': '以前',
        'SAVE': '救',
        'ERR_OWNKEY': '輸入的員工編號已存儲在數據庫中，請嘗試其他',
        'ERR_BOSSKEY': '輸入的老闆號碼未存儲在數據庫中，請嘗試其他號碼',
        'ERR_VAL_1': '在字段中輸入的數據：',
        'ERR_VAL_2': '包含非法字符，或格式不正確',
        'GUARDANDO': '參與者信息正在存儲中，請稍候',
        'GUARDANDO_GOFLOW': '信息正在存儲中，請稍候。',
        'SAVE_OK': '新參與者的信息已正確存儲',
        'MOD_OK': '參加者信息已成功修改',
        'FORMULARIO': '您尚未填寫註冊表，請檢查是否已填寫所有必填字段，然後重試',
        'ACCIONES': '用戶動作',
        'VERACT': '用戶動作',
        'LOADACT': '加載可用動作',
        'NOACT': '無法為此貢獻者執行其他操作',
        'AVAACT': '可以為此協作者執行以下操作',
        'ACCIONLIST': {
          'modificar': '修改所選協作者的信息',
          'borrar': '刪除所選的協作者'
        },
        'DELCOLAB': '您確定要從該產品中刪除所選的協作者嗎？注意：此操作無法撤消',
        'DEL_OK': '該協作者已成功從產品中刪除',
        'ERR_EMAIL': '輸入的電子郵件地址已存儲在數據庫中，請嘗試其他電子郵件地址',
        'ERR_SAMEKEY': '輸入的上司密鑰和協作者密鑰相同，這是不允許的，請嘗試其他密鑰',
        'RESET_COLAB_SURVE': '您確認重置調查訪問權限嗎？ ',
        'ACTU_OK': '它已正確更新',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': '看法',
        'statementID': '反應式 ID',
        'dimensionL1': '尺寸 L1',
        'dimensionL2': '尺寸 L2',
        'survey_Score_OverallTI': 'GlobalTI 分數調查',
        'company_Country': '國家公司',
        'cgo_Product_Name': '產品名稱 cgo',
        'company_Name': '公司名',
        'ranking_Year': '排名年份',
        'survey_Respondents': '受訪者',
        'survey_Score_Camaraderie': '友情分數調查',
        'survey_Score_Credibility': '信譽評分調查',
        'survey_Score_Imparciality': '公正性評分調查',
        'survey_Score_Pride': '驕傲分數調查',
        'survey_Score_Respect': '尊重分數調查',
        'survey_Score_Gestalt': '格式塔分數調查',
        'pdf_DateCreation': '證書創建日期',
        'WARNI_TI_DA':'輸入的值不符合允許的格式 (100.00)',
        'WARNI_TI_DA_GRAL':'輸入的數據不是指定的格式',
      },
      'FORMULARIO':{
        'fullName': '全名',
        'ownKey': '員工編號',
        'age': '出生年份',
        'surveyKey': '調查訪問密鑰',
        'email': '電子郵件',
        'bossName': '直接老闆姓名',
        'bossKey': '直接老闆號碼',
        'country': '國家',
        'location': '位置',
        'geo_1': '地理等級1',
        'geo_2': '地理等級2',
        'geo_3': '地理級別3',
        'geo_4': '地理等級4',
        'geo_5': '地理等級5',
        'geo_6': '地理等級6',
        'geo_7': '地理等級7',
        'geo_8': '地理級別8',
        'geo_9': '地理等級9',
        'geo_10': '地理級別10',
        'geo_19': '地理級別19',
        'structure_1': '結構一級',
        'structure_2': '結構等級2',
        'structure_3': '結構等級3',
        'structure_4': '結構等級4',
        'structure_5': '結構等級5',
        'structure_6': '結構等級6',
        'structure_7': '結構等級7',
        'structure_8': '結構等級8',
        'structure_9': '結構層9',
        'structure_10': '結構層10',
        'area': '區',
        'bUnit': '業務部門',
        'enterDate': '進入公司的日期',
        'antiquity': '古代',
        'antiquityUS': '上古我們',
        'generation': '代',
        'generationUS': '一代我們',
        'ageUS': '年齡',
        'charge': '在公司中的職位或職能',
        'homologado': '充電或功能批准',
        'homologadoUS': '收費或功能批准了我們',
        'gender': '性別',
        'genderType': '性別類型',
        'typeofwork': '補償類型',
        'workCondition': '工作條件',
        'academico': '學位',
        'contratacion': '合同類型',
        'situacionUS': '我們的工作情況',
        'personal': '員工類型',
        'jornada': '工作時間表類型',
        'rotacion': '確實旋轉',
        'phone': '合作者的電話',
        'extension': '合作者的直接擴展',
        'cellphone': '合作者的手機',
        'native': '母語',
        'answer': '回答',
        'other_1': '其他1',
        'other_2': '其他2',
        'other_3': '其他3',
        'other_4': '其他4',
        'other_5': '其他5',
        'other_6': '其他6',
        'other_7': '其他7',
        'other_8': '其他8',
        'other_9': '其他9',
        'other_10': '其他10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'與計數門戶同步，請等待...',
        'SUCCESS':'同步正確完成'
      }
    },
  }
};
